export default "__VITE_ASSET__8Ej7RLuF__"